/* eslint-disable no-unused-vars */
import React, { useContext, useState, useRef } from "react";
import { withRouter, Link } from "react-router-dom";
import _ from "lodash";
import { connect } from "react-redux";
import { ModalContext } from "App";
import Modal from "modules/common/components/Modal";
import PropTypes from "prop-types";
import * as actions from "../action";
import * as c from "../constant";

const form = {
  pin: "",
};

function UpdatePinModalContainer({
  mobileNo,
  updateValidateOtp,
  resendUpdateValidateOtp,
  isLoading,
  showTransaction,
  getTransactionList,
  taxPayerId,
}) {
  const replaced =
    mobileNo.slice(0, 2) + mobileNo.slice(2).replace(/.(?=...)/g, "*");

  const [formData, setFormData] = useState(form);

  const handleOnChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const setModal = useContext(ModalContext);

  const handleResendOtp = e => {
    e.preventDefault();
    resendUpdateValidateOtp(taxPayerId);
  };

  const handleOnSubmit = e => {
    e.preventDefault();
    updateValidateOtp(taxPayerId,
      { pin: formData.pin },
      (res) => {
        setModal({ isOpen: false });
        getTransactionList();
        showTransaction(taxPayerId);
      }
    );
  };

  return (
    <Modal.Body className="p-0">
      <div className="forgot-container">
        <div className="container-fluid">
          <div className="row">
            <div className="form-section col-12 d-flex align-items-center">
              <div className="form-content w-100">
                <h2 className="form-title font-weight-bold mb-3">
                  SMS Verification
                </h2>
                <p className="form-sub-title">
                  A verification sms has been sent to +{replaced}.
                </p>
                <p className="form-sub-title">
                  Enter OTP to update the mobile number.
                </p>
                <form onSubmit={handleOnSubmit}>
                  <div id="divOuter" className="form-group form-row">
                    <div id="divInner">
                      <input
                        id="partitioned"
                        name="pin"
                        autoFocus
                        autoComplete="off"
                        required
                        className="otp-value"
                        type="tel"
                        maxLength="6"
                        onChange={handleOnChange}
                      />
                      <div className="profile-under" />
                    </div>
                  </div>
                  <Link
                    to="/"
                    onClick={handleResendOtp}
                    className="sign-up mt-3 d-block"
                  >
                    Didn`t Receive OTP? <strong>Resend.</strong>
                  </Link>
                  <button
                    type="submit"
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary  w-100 mt-4 cms-bg-color-primary"
                    disabled={isLoading}
                  >
                    {isLoading && <i className="fa fa-spin fa-spinner" />}{" "}
                    Confirm OTP
                  </button>
                  {/* <Link
											to='/'
											onClick={handleResendOtp}
											className='sign-up mt-3 d-block'>
											Don’t have account yet? <strong>Sign up here.</strong>
										</Link> */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal.Body>
  );
}

UpdatePinModalContainer.propTypes = {
  mobileNo: PropTypes.string.isRequired,
  taxPayerId: PropTypes.string.isRequired,
  updateValidateOtp: PropTypes.instanceOf(Function).isRequired,
  resendUpdateValidateOtp: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: _.get(api, "loading", []).indexOf(c.UPDATE_VALIDATE_OTP) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(UpdatePinModalContainer);
